import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  selectCurrentToken,
  selectAuthError,
  clearAuthError,
  selectSelectedRole,
} from "./authSlice";
import ROLES_LIST from "../../RoleList.mjs";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import MenuActivityTracker from "./MenuActivityTracker";

const RequireAuth = () => {
  const token = useSelector(selectCurrentToken);
  const selectedRole = useSelector(selectSelectedRole);
  const error = useSelector(selectAuthError);
  const location = useLocation();
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(clearAuthError());
  };

  if (!token && error) {
    return (
      <Dialog open={true} onClose={handleClose}>
        <DialogTitle>Session Expired</DialogTitle>
        <DialogContent>
          <DialogContentText>{error}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  const tendikAllowedPaths = [
    "/profile",
    "/dashboard",
    "/create-identitas",
    "/strucktur-organisasi",
    // "/buku-tabungan", // Buku Tabungan guru/karyawan sementara di-hide
  ];

  if (
    token &&
    selectedRole === ROLES_LIST.TENDIK &&
    !tendikAllowedPaths.includes(location.pathname)
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  return token ? (
    <>
      <MenuActivityTracker />
      <Outlet />
    </>
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};
export default RequireAuth;
